{
  "title": "Apply Filter",
  "clear": "Clear Filter",
  "sections": {
    "status": {
      "title": "Status",
      "options": {
        "active": "Active",
        "closed": "Closed",
        "pending": "Pending",
        "frozen": "Frozen",
        "edd": "EDD"
      }
    },
    "type": {
      "title": "Customer Type",
      "options": {
        "individual": "Individual",
        "corporation": "Corporation"
      }
    },
    "onboarddate": {
      "title": "Onboard Date",
      "options": {
        "startdate": "Start Date",
        "enddate": "End Date"
      }
    }
  }
}
